var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 8",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7149 1.08088L11.1374 0.503138C10.9372 0.313218 10.7035 0.218231 10.4366 0.218231C10.1643 0.218231 9.93333 0.313218 9.74333 0.503138L6.00001 4.24655L2.25673 0.503246C2.06676 0.313326 1.83572 0.218339 1.56349 0.218339C1.29653 0.218339 1.06282 0.313326 0.862652 0.503246L0.292676 1.08099C0.0975228 1.27601 0 1.50971 0 1.78189C0 2.05913 0.0976307 2.29019 0.292649 2.47501L5.30675 7.48913C5.49168 7.68418 5.72263 7.78178 5.99999 7.78178C6.27213 7.78178 6.50581 7.68421 6.70078 7.48913L11.7149 2.47501C11.9049 2.28498 12 2.05395 12 1.78189C12 1.51478 11.9049 1.28121 11.7149 1.08088Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronArrowDown);
export default __webpack_public_path__ + "static/media/chevron-arrow-down.48c85d24277eca4b2d5745e6f095f73d.svg";
export { ForwardRef as ReactComponent };